<template>
    <div class="table_no_container">
        <div class="search_cont">
            <el-form
                :inline="true"
                :model="searchForm"
                class="leader-style-form leader-form-inner-tab-inline"
            >
                <el-form-item label="时间" style="float: left">
                    <el-date-picker
                        v-model="time"
                        align="right"
                        type="date"
                        :clearable="false"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        @change="handleTimeChange"
                        v-show="tabVal === 'day'"
                    ></el-date-picker>
                    <el-date-picker
                        v-model="time"
                        type="month"
                        :clearable="false"
                        placeholder="选择月"
                        value-format="yyyy-MM"
                        :picker-options="pickerOptions"
                        @change="handleTimeChange"
                        v-show="tabVal === 'month'"
                    ></el-date-picker>
                    <el-date-picker
                        v-model="time"
                        type="year"
                        placeholder="选择年"
                        format="yyyy"
                        value-format="yyyy"
                        :clearable="false"
                        :picker-options="pickerOptions"
                        @change="handleTimeChange"
                        v-show="tabVal === 'year'"
                    ></el-date-picker>
                    <el-button
                        size="small"
                        @click="forwardTimeClick"
                        style="margin-left: 10px"
                    >
                        上一{{
                            tabVal === "day"
                                ? "日"
                                : tabVal === "month"
                                ? "月"
                                : "年"
                        }}
                    </el-button>
                    <el-button
                        size="small"
                        :disabled="nextTimeDisabled"
                        @click="nextTimeClick"
                    >
                        下一{{
                            tabVal === "day"
                                ? "日"
                                : tabVal === "month"
                                ? "月"
                                : "年"
                        }}
                        <!-- <i class="el-icon-caret-right"></i> -->
                    </el-button>
                    <el-button
                        type="primary"
                        size="small"
                        @click="handleSearchReport"
                        >查询</el-button
                    >
                </el-form-item>
                <div style="text-align: end;">
                    <el-button
                        class="active-table"
                        v-show="isBM"
                        type="primary"
                        size="small"
                        @click="changeBMOrNot(false)"
                        >标煤</el-button
                    >
                    <el-button
                        class="active-table-data"
                        v-show="!isBM"
                        type="primary"
                        size="small"
                        @click="changeBMOrNot(true)"
                        >电量</el-button
                    >
                    <el-button
                        class="active-table-data"
                        v-show="isTable"
                        type="primary"
                        size="small"
                        @click="changeTableOrChart(false)"
                        >数据</el-button
                    >
                    <el-button
                        class="active-table"
                        v-show="!isTable"
                        type="primary"
                        size="small"
                        @click="changeTableOrChart(true)"
                        >图表</el-button
                    >
                </div>
            </el-form>
        </div>
        <div class="table_cont-wrap">
            <div class="table_top">
                <div class="tl_cont">
                    <h2>电能占比</h2>
                    <v-chart
                        :auto-resize="true"
                        :options="pieBar"
                        ref="pieBar"
                        theme="ovilia-green"
                    />
                </div>
                <div class="tr_cont">
                    <h2>表节点汇总</h2>
                    <template v-if="isTable">
                        <el-table
                            class="leader-style-table"
                            :data="tableData"
                            height="100%"
                            style="width: 100%"
                        >
                            <el-table-column
                                prop="point_name"
                                label="采集点"
                            ></el-table-column>
                            <!-- <el-table-column label="时间">
                                <template slot-scope="scope">
                                    <span v-if="tabVal == 'day'"
                                        >{{ scope.row.show_day }}时</span
                                    >
                                    <span v-else-if="tabVal == 'month'"
                                        >{{ scope.row.show_day }}日</span
                                    >
                                    <span v-else-if="tabVal == 'year'"
                                        >{{ scope.row.show_day }}月</span
                                    >
                                </template>
                            </el-table-column> -->
                            <el-table-column
                                prop="active_power"
                                label="电量（kW·h）"
                                v-if="!isBM"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="active_power"
                                label="标煤（tce）"
                                v-else
                            >
                            </el-table-column>
                        </el-table>
                    </template>
                    <template v-else>
                        <v-chart
                            :auto-resize="true"
                            :options="lineBar"
                            ref="lineBar"
                            theme="ovilia-green"
                        />
                    </template>
                </div>
            </div>
            <div class="table_btm">
                <h2>分时统计</h2>
                <template v-if="isTable">
                    <el-table
                        class="leader-style-table"
                        :data="tableHData"
                        height="100%"
                        style="width: 100%"
                    >
                        <el-table-column
                            prop="point_name"
                            label="采集点"
                        ></el-table-column>
                        <el-table-column label="时间">
                            <template slot-scope="scope">
                                <span v-if="tabVal == 'day'"
                                    >{{ scope.row.show_day }}时</span
                                >
                                <span v-else-if="tabVal == 'month'"
                                    >{{ scope.row.show_day }}日</span
                                >
                                <span v-else-if="tabVal == 'year'"
                                    >{{ scope.row.show_day }}月</span
                                >
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="active_power"
                            label="电量（kW·h）"
                            v-if="!isBM"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="active_power"
                            label="标煤（tce）"
                            v-else
                        >
                        </el-table-column>
                    </el-table>
                </template>
                <template v-else>
                    <v-chart
                        :auto-resize="true"
                        :options="line2Bar"
                        ref="line2Bar"
                        theme="ovilia-green"
                    />
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/chart/pie";
// import moment from "moment";
import dayjs from "dayjs";
import * as api from "@/http/api.js";
export default {
    components: {},
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            time: "",
            todayY: "",
            todayM: "",
            todayD: "",
            nextTimeDisabled: false,
            isTable: false,
            isBM: false,
            tableData: [],
            table2Data: [],
            xAxis: [],
            yAxis: [],
            xHAxis: [],
            yHAxis: [],
            pieData: [],
            systemDate: ""
        };
    },
    props: {
        curTab: {
            type: String,
            default: ""
        },
        tabVal: {
            type: String,
            default: "day"
        },
        curPointId: {
            type: String,
            default: ""
        },
        pointName: {
            type: String,
            default: ""
        }
    },
    created() {
        this.getSysDate("day");
        this.todayY = this.getTimeValue("year");
        this.todayM = this.getTimeValue("month");
        this.todayD = this.getTimeValue("day");
        this.nextTimeDisabled = true;
    },
    methods: {
        /**
         * 获取系统时间
         */
        getSysDate(type) {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.systemDate = res.bus_json;
                    this.time = res.bus_json.sysdate;
                }
            });
        },
        changeTableOrChart(isTable) {
            this.isTable = isTable;
        },
        changeBMOrNot(isBM) {
            this.isBM = isBM;
            this.handleSearchReport();
        },
        /**
         * 日期改变回调函数
         */
        handleTimeChange(val) {
            let toDay = new Date(this.toDay).getTime();
            let selectTime = new Date(val).getTime();
            if (selectTime >= toDay) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        },
        /**
         * 获取时间值
         * params{type<string>} type = day(日) type = month(月) type = year(年)
         */
        getTimeValue(type) {
            let date = new Date();
            if (type === "year") {
                return date.getFullYear() + "";
            } else if (type === "month") {
                return date.getFullYear() + "-" + (date.getMonth() + 1);
            } else {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }
        },
        /**
         * 选择搜索
         */
        handleSearchReport() {
            if (this.tabVal === "day") {
                this.getDayData();
            } else if (this.tabVal === "month") {
                this.getMonthData();
            } else {
                this.getYearData();
            }
        },
        /**
         * 获取日报列表
         */
        getDayData() {
            if (!this.curPointId) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let params = {
                tree_unit_id: this.curPointId,
                cur_date: this.time,
                type: 1,
                is_tce: this.isBM ? 1 : 0
            };
            this.queryData(params);
        },
        /**
         * 获取月报列表
         */
        getMonthData() {
            if (!this.curPointId) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let params = {
                tree_unit_id: this.curPointId,
                cur_date: this.time,
                type: 2,
                is_tce: this.isBM ? 1 : 0
            };
            this.queryData(params);
        },
        /**
         * 获取年报列表
         */
        getYearData() {
            if (!this.curPointId) {
                this.$message({
                    message: "请选择节点后进行查询操作！",
                    type: "warning"
                });
                return;
            }
            let params = {
                tree_unit_id: this.curPointId,
                cur_date: this.time,
                type: 3,
                is_tce: this.isBM ? 1 : 0
            };
            this.queryData(params);
        },
        queryData(params) {
            if (this.tabVal === "day") {
                params.cur_date = dayjs(new Date(this.time)).format(
                    "YYYY-MM-DD"
                );
            } else if (this.tabVal === "month") {
                params.cur_date = dayjs(new Date(this.time)).format("YYYY-MM");
            } else {
                params.cur_date = dayjs(new Date(this.time)).format("YYYY");
            }
            this.tableLoading = true;
            api.getEnergyComposeH(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xAxis = [];
                    this.yAxis = [];
                    this.pieData = [];
                    if (res.bus_json.length) {
                        res.bus_json.forEach(item => {
                            item.name = this.point_name;
                            this.xAxis.push(item.point_name);
                            this.yAxis.push(item.active_power);
                            //if(item.active_power > 0)
                            this.pieData.push({
                                value: item.active_power,
                                name: item.point_name
                            });
                        });
                    }
                    this.tableData = res.bus_json;
                }
                this.tableLoading = false;
            });
            this.tableHLoading = true;
            api.getEnergyTrendH(params).then(res => {
                if (res && res.error_code === "0") {
                    this.xHAxis = res.bus_json.time_list;
                    this.yHAxis = res.bus_json.active_power_list;
                    this.tableHData = [];
                    if (
                        res.bus_json.time_list &&
                        res.bus_json.active_power_list
                    ) {
                        res.bus_json.time_list.forEach((item, index) => {
                            this.tableHData.push({
                                point_name: this.pointName,
                                active_power:
                                    res.bus_json.active_power_list[index],
                                show_day: item
                            });
                        });
                    }
                }
                this.tableHLoading = false;
            });
        },
        /**
         * 上一日、上一月、上一年点击
         */ forwardTimeClick() {
            this.nextTimeDisabled = false;
            if (this.tabVal === "day") {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = dayjs(new Date(this.time))
                    .subtract(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
        },
        /**
         * 下一日、下一月、下一年点击
         */
        nextTimeClick() {
            let todayD = new Date(this.todayD).getTime();
            let todayM = new Date(this.todayM).getTime();
            let todayY = new Date(this.todayY).getTime();
            if (this.tabVal === "day") {
                this.time = dayjs(new Date(this.time))
                    .add(1, "days")
                    .format("YYYY-MM-DD");
            } else if (this.tabVal === "month") {
                this.time = dayjs(new Date(this.time))
                    .add(1, "months")
                    .format("YYYY-MM");
            } else {
                this.time = dayjs(new Date(this.time))
                    .add(1, "years")
                    .format("YYYY");
            }
            // 获取报告列表
            this.handleSearchReport();
            let selectTime = new Date(this.time).getTime();
            if (
                (this.tabVal === "day" && selectTime >= todayD) ||
                (this.tabVal === "month" && selectTime >= todayM) ||
                (this.tabVal === "year" && selectTime >= todayY)
            ) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
        }
    },
    watch: {
        tabVal(newVal, oldVal) {
            if (newVal != oldVal && this.curTab == "2") {
                this.nextTimeDisabled = true;
                if (newVal == "day") {
                    this.time = this.systemDate.sysdate;
                    this.getDayData();
                }
                if (newVal == "month") {
                    this.time = this.systemDate.sysdate3;
                    this.getMonthData();
                }
                if (newVal == "year") {
                    this.time = this.systemDate.sysdate4;
                    this.getYearData();
                }
            }
        },
        curPointId(newVal, oldVal) {
            if (newVal != oldVal && this.curTab == "2") {
                if (this.tabVal == "day") this.getDayData();
                if (this.tabVal == "month") this.getMonthData();
                if (this.tabVal == "year") this.getYearData();
            }
        }
    },
    computed: {
        pieBar() {
            const option = {
                color: [
                    "#13C2F0",
                    "#EEC671",
                    "#3EF5A3",
                    "#46B298",
                    "#FF947F",
                    "#71C3F1",
                    "#D7FFDD",
                    "#4C7CA2",
                    "#0479C5",
                    "#EFFFDB",
                    "#700305"
                ],
                tooltip: {
                    trigger: "item",
                    formatter: "{b} : {c} ({d}%)",
                    position: ["50%", "50%"]
                },
                series: [
                    {
                        name: "",
                        type: "pie",
                        radius: "80%",
                        center: ["50%", "50%"],
                        data: this.pieData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        },
                        label: {
                            normal: {
                                position: "inner",
                                formatter: "{b}\n{d}%"
                                //rotate: '45',
                            }
                        }
                    }
                ]
            };
            return option;
        },
        lineBar() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    top: "15%",
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            color: "#999",
                            fontSize: 14
                        },
                        axisLine: { lineStyle: { color: "#999" } },
                        data: this.xAxis
                    }
                ],
                yAxis: [
                    {
                        name: this.isBM ? "tce" : "kW·h",
                        axisLabel: {
                            color: "#999",
                            fontSize: 14
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ["#999"]
                            }
                        },
                        axisLine: { lineStyle: { color: "#999" } },
                        type: "value"
                    }
                ],
                series: [
                    {
                        type: "bar",
                        barWidth: 40,
                        itemStyle: {
                            normal: {
                                // color: function (params) {
                                //     var colorList = ["#13C2F0", "#EEC671", "#3EF5A3", "#46B298", "#FF947F"];
                                //     return colorList[params.dataIndex];
                                // },
                                color: "#FF947F"
                            }
                        },
                        data: this.yAxis
                    }
                ]
            };
            return option;
        },
        line2Bar() {
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    top: "15%",
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            color: "#999",
                            fontSize: 14
                        },
                        axisLine: { lineStyle: { color: "#999" } },
                        data: this.xHAxis
                    }
                ],
                yAxis: [
                    {
                        name: this.isBM ? "单位:tce" : "单位:kW·h",
                        axisLabel: {
                            color: "#999",
                            fontSize: 14
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ["#999"]
                            }
                        },
                        axisLine: { lineStyle: { color: "#999" } },
                        type: "value"
                    }
                ],
                series: [
                    {
                        type: "bar",
                        barWidth: 40,
                        itemStyle: {
                            normal: {
                                // color: "#13C2F0",
                            }
                        },
                        data: this.yHAxis
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.table_no_container {
    height: calc(100% - 55px);
    .search_cont {
        width: 100%;
        margin: 15px 0 20px 0;
        .form {
            display: flex;
            justify-content: space-between;
            .button-group {
                display: inline-block;
                margin-left: 20px;
                .el-button.is-disabled,
                .el-button.is-disabled:focus,
                .el-button.is-disabled:hover {
                    border-color: #ebeef5;
                }
            }
        }
    }
    .table_cont-wrap {
        width: 100%;
        height: calc(100% - 55px - 7rem);
        padding: 0;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        .table_top {
            height: 53%;
            width: 100%;
            display: inline-flex;
            align-items: center;
            box-sizing: border-box;
            .tl_cont {
                width: 25%;
                height: 100%;
                /*background: url(../../../../../assets/image/leaderpage/s-left1.png)*/
                /*    no-repeat;*/
                background-size: 100% 100%;
                .echarts {
                    height: 100%;
                    width: 100%;
                }
                h2 {
                    color: #fff;
                    position: absolute;
                    top: 1%;
                    left: 2%;
                    font-size: 0.8rem;
                }
            }
            .tr_cont {
                width: 73%;
                height: 100%;
                margin-left: 2%;
                /*background: url(../../../../../assets/image/leaderpage/ops-m-bottom.png)*/
                /*    no-repeat;*/
                background-size: 100% 100%;
                position: relative;
                box-sizing: border-box;
                padding: 30px 30px 0 30px;
                .echarts {
                    height: 95%;
                    width: 100%;
                }
                h2 {
                    color: #fff;
                    position: absolute;
                    top: 2%;
                    left: 5%;
                    font-size: 0.8rem;
                }
            }
        }
        .table_btm {
            height: 44%;
            margin-top: 1%;
            /*background: url(../../../../../assets/image/leaderpage/kuai.png)*/
            /*    no-repeat;*/
            background-size: 100% 100%;
            position: relative;
            box-sizing: border-box;
            padding: 30px 30px 0 30px;
            .echarts {
                height: 95%;
                width: 100%;
            }
            h2 {
                color: #fff;
                position: absolute;
                top: 2%;
                left: 2.2%;
                font-size: 0.8rem;
            }
        }
    }
}
</style>
